/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type DesignServiceBanner_user$ref = any;
export type DesignServiceBanner_user = {
    readonly isVip: boolean | null;
    readonly isVerifiedTrade: boolean | null;
    readonly " $refType": DesignServiceBanner_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "DesignServiceBanner_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isVip",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isVerifiedTrade",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '72299bfe89133f833d5d3e912e5a51fb';
export default node;
